/* 🤖 this file was generated by svg-to-ts */
export const matIconPlusOne: {
  name: 'plus-one';
  data: string;
} = {
  name: 'plus-one',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10 8H8v4H4v2h4v4h2v-4h4v-2h-4V8zm4.5-1.92V7.9l2.5-.5V18h2V5l-4.5 1.08z"/></svg>`
};
